import React from 'react'

import {
  RadioOptionLabel, RadioOptionHiddenInput,
} from './styles'

import { Props } from './types'

const RadioOption: React.FC<Props> = ({
  children,
  id,
  isChecked,
  name,
  onChange,
  value,
}): React.ReactElement => (
  <RadioOptionLabel key={value as string} htmlFor={id} checked={isChecked}>
    <RadioOptionHiddenInput
      id={id}
      checked={isChecked}
      name={name}
      value={value as string}
      onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault()

        onChange && onChange(value)
      }}
    />
    {children}
  </RadioOptionLabel>
)

export * from './types'

export default RadioOption
